const EditTargetArea = ({
	serviceAreas,
	handleTargetAreaSelectChange,
	targetArea,
}) => {
	return <div className="service-modal__step-one">
		<p className="service-modal__text">I am here for</p>
		<select name="target-area" className="service-modal__select" onChange={handleTargetAreaSelectChange} value={targetArea?.slug}>
			{serviceAreas.map(s => (
				<option value={s.slug} key={s.slug}>
					{s.name}
				</option>
			))}
		</select>
	</div>;
}
 
export default EditTargetArea;